export const TEAM_MODEL = {
  ID: 'id',
  ORG_ID: 'organization_id',
  COLOR: 'color',
  CONTRIBUTOR_IDS: 'contributor_ids',
  CONTRIBUTORS: 'contributors',
  CREATED_AT: 'created_at',
  DELETED_AT: 'deleted_at',
  UPDATED_AT: 'updated_at',
  INITIALS: 'initials',
  NAME: 'name',
  PROJECT_ID: 'project_id'
};

export const SYNCED_TEAM_MODEL = {
  ...TEAM_MODEL,
  IS_SYNCED: 'isSynced',
  SYNCED_PROVIDER_NAME: 'syncedProviderName'
};

export const TEAM_TABLE_MODEL = {
  NAME_COMP: 'name_comp',
  CONTRIBUTORS_COUNT_COMP: 'countributors_count_comp',
  CREATED_AT_COMP: 'created_at_comp',
  OPTIONS_COMP: 'options'
};
